/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import PropTypes from 'prop-types';
import { Colors } from 'utils';

const PlayerIcon = ({ color, width, height }) => {
  return (
    <svg
      height={`${height || '20'}px`}
      width={`${width || '22'}px`}
      viewBox="0 0 22 20"
      css={css`
        fill: ${color || Colors.primaryColor};
        max-width: ${width || '22'}px;
        max-height: ${height || '20'}px;
        height: ${height || '20'}px;
        width: ${width || '22'}px;
      `}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.1972 0C9.70135 0 8.48861 1.17723 8.48861 2.62932C8.48861 4.08141 9.70135 5.25864 11.1972 5.25864C12.6935 5.25864 13.9046 4.08141 13.9046 2.62932C13.9046 1.17723 12.6935 0 11.1972 0ZM11.1972 4.14165C10.3379 4.14165 9.6393 3.46308 9.6393 2.62932C9.6393 1.79557 10.3379 1.11699 11.1972 1.11699C12.0553 1.11699 12.754 1.79557 12.754 2.62932C12.754 3.46308 12.0553 4.14165 11.1972 4.14165ZM9.49386 6.40739H12.8999C14.1812 6.40739 15.23 7.42505 15.23 8.6689V12.9857C15.23 14.0177 14.5071 14.8921 13.5291 15.1606V20H12.3784L12.3767 14.1302H12.8999C13.55 14.1302 14.0793 13.6168 14.0793 12.9857V8.6689C14.0793 8.0378 13.55 7.52438 12.8999 7.52438H9.49386C8.84372 7.52438 8.31482 8.0378 8.31482 8.6689V12.9857C8.31482 13.6168 8.84372 14.1302 9.49386 14.1302H10.0182L10.0145 20H8.86386V15.1602C7.8866 14.8914 7.16413 14.0177 7.16413 12.9857V8.6689C7.16413 7.42505 8.2129 6.40739 9.49386 6.40739ZM2.64938 9.92935L5.15746 9.92895C5.47513 9.92895 5.73281 10.1791 5.73281 10.4874C5.73281 10.7958 5.47513 11.0459 5.15746 11.0459L2.65432 11.0463L3.52185 11.8885C3.74623 12.1063 3.74623 12.4597 3.52185 12.678C3.40925 12.7873 3.26212 12.8415 3.115 12.8415C2.96747 12.8415 2.82034 12.7873 2.70815 12.678L0.867469 10.8868C0.726921 10.7499 0.67514 10.5597 0.710893 10.3829C0.730208 10.2732 0.781989 10.1675 0.869112 10.0825L0.914729 10.0379C0.91514 10.0379 0.91514 10.0375 0.91514 10.0371L2.70938 8.29136L2.71103 8.28976L2.75623 8.24588C2.98103 8.02767 3.34514 8.02767 3.56993 8.24588C3.79473 8.4641 3.79473 8.81754 3.56993 9.03576L2.64938 9.92935ZM21.5313 10.0825C21.6439 10.1914 21.6998 10.3347 21.6998 10.4779C21.7035 10.6255 21.6484 10.7743 21.5325 10.8868L19.6877 12.678C19.5751 12.7873 19.4284 12.8415 19.2809 12.8415C19.1338 12.8415 18.9866 12.7873 18.874 12.678C18.6492 12.4597 18.6492 12.1063 18.874 11.8885L19.7411 11.0463L17.2343 11.0459C16.9166 11.0459 16.659 10.7958 16.659 10.4874C16.659 10.1787 16.9166 9.92895 17.2343 9.92895L19.7457 9.92935L18.8255 9.03576C18.6007 8.81754 18.6007 8.4641 18.8255 8.24588C19.0499 8.02767 19.414 8.02767 19.6388 8.24588L19.684 8.28976L19.6857 8.29096L21.5313 10.0825Z"
        fill={`${color || Colors.primaryColor}`}
      />
    </svg>
  );
};

export default PlayerIcon;

PlayerIcon.propTypes = {
  color: PropTypes.string,
  height: PropTypes.number,
  width: PropTypes.number,
};
